module.exports = __webpack_public_path__ + "static/media/logo.3219d4ae.png";